import { render, staticRenderFns } from "./WatSponsorPostulations.vue?vue&type=template&id=5e80dc14&"
import script from "./WatSponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./WatSponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports